module.exports = __webpack_public_path__ + "img/React.4009eef3.svg";